import { ReactNode } from "react";
import classNames from "classnames";
import styles from "./cell.module.scss";
import { Cell, CellAlignment, CoreCellProps } from "./cell";

export interface ActionCellProps extends CoreCellProps {
  alignment?: CellAlignment;
  children: ReactNode;
}

export const CellAction = ({
  alignment,
  children,
  ...rest
}: ActionCellProps) => {
  const cellClassNames = classNames(styles.cellAction);

  return (
    <div className={cellClassNames}>
      <Cell alignment={alignment || "center"} focusable={false} {...rest}>
        {children}
      </Cell>
    </div>
  );
};
